// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    defaultChooseLabel: {
        id: 'actions.defaultChooseLabel',
        defaultMessage: 'Choose...'
    },
    removeFromAction: {
        id: 'actions.removeFromAction',
        defaultMessage: 'Remove from action'
    }
});



// WEBPACK FOOTER //
// ./src/components/widgets/actions/action-attribute/intl.js